import React from 'react';
import PropTypes from 'prop-types';
import FloatingPanel from '../../../components/Panel/FloatingPanel';
import AddContentSectionForm from './AddContentSectionForm';
import { getPhotoCurrentUser } from '../../../service/s3Amplify';
import Snackbar from '@material-ui/core/Snackbar';
import CustomNotification from '../../Notification/CustomNotification';
class AddContentSection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      files: [],
      selectedPicture: null,
      urlPreview:'',
      errorMessage:'',
      attachment:null,
      openNotification : false,
      messageNotification : 'Selecciona un archivo válido',
      typeNotification : "warning"
    };
    this.onClean = this.onClean.bind(this);
  }

  onClean(band){
    if(band){
      this.setState({
        selectedPicture:null,
        urlPreview:'',
        errorMessage:'',
        attachment:null
      });
    }else{
      Promise.all([getPhotoCurrentUser(this.props.dataInit.cont_imagePath)])
      .then(response =>{
        this.setState({
          urlPreview :response[0],
          selectedPicture :null
        });
      }).catch(err =>{
        console.log("error url", err);
      });
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.dataInit !== null){
      console.log(newProps.dataInit.cont_imagePath)
      Promise.all([getPhotoCurrentUser(newProps.dataInit.cont_imagePath)])
      .then(response =>{
        this.setState({
          urlPreview :response[0],
        });
      }).catch(err =>{
        console.log("error url", err);
      });
    }else{
      this.setState({
        urlPreview: this.state.selectedPicture ? this.state.selectedPicture.preview : ''
      });
    }

    if(!this.props.openForm){
      this.onClean(true);
    }

  }

  onDrop=(files)=> {
    if(files.length===0){
      this.setState({errorMessage:"archivo inválido"});
    }else{
      if (files.length > 1) {
        this.setState({
          errorMessage : 'No puedes subir más de un archivo'
        });
      } else {
        this.setState({ selectedPicture: files[0] ,errorMessage:''});        
      }
    }    
  }

  addAttachment = (files)=>{
    if(files[0]){
      this.setState({
        attachment : files[0]
      });
    }else{
      this.setState(
        {
          attachment : null,
          openNotification : true
        }
      )
    }
  }

  handleCloseNotification = () => {
    this.setState(
      {
        openNotification : false
      }
    )
  }

  sendValues = (values) => {
    setTimeout(() => {
      this.props.submit(values, this.state.img);
      this.setState({ img: '' });
    }, 500);
  }

  render() {
    const {
      openForm,
      closeForm,
      dataInit,
      submit,
      contentType,
      action,
      isLoading
    } = this.props;
    const branch = '';
    return (
      <div>
        <FloatingPanel title={`${action} Tarjeta`} openForm={openForm} branch={branch} closeForm={closeForm}>
          <AddContentSectionForm
            onDrop={this.onDrop}
            handleSubmit={(event, data)=>submit(event, data, this.state.selectedPicture, this.state.attachment)}
            dataInit={dataInit}
            contentType={contentType}
            preview={this.state.selectedPicture ? this.state.selectedPicture.preview :this.state.urlPreview}
            onClean={this.onClean}
            isOpen={openForm}
            errorMessage={this.state.errorMessage}
            errorMessage2={this.state.errorMessage2}
            addAttachment={this.addAttachment}
            attachment={this.state.attachment}
            isLoading={isLoading}
          />
        </FloatingPanel>
        <Snackbar
         anchorOrigin={{
             vertical: 'top',
             horizontal: 'right',
         }}
         open={this.state.openNotification}
         autoHideDuration={6000}
         onClose={this.handleCloseNotification}>
       <CustomNotification
         onClose={this.handleCloseNotification}
         variant={this.state.typeNotification}
         message={this.state.messageNotification}/>
       </Snackbar>
      </div>
    );
  }
}

AddContentSection.propTypes = {
  classes: PropTypes.object,
  submit: PropTypes.func,
  addContact: PropTypes.func,
  openForm: PropTypes.bool,
  closeForm: PropTypes.func,
  dataInit:PropTypes.object,
  contentType:PropTypes.string,
  action: PropTypes.string
};

export default (AddContentSection);
